import { isNilOrEmpty } from 'packages/core'
import config from 'config'

export const smallScreenWidth = '1022px'
export const mobileScreenWidth = '767px'
export const headerHeight = 70
export const subHeaderHeight = 80

export const ITEMS_VIEW = {
    LIST: 'list',
    CARD: 'card',
}

export const getFullImageUrl = (imagePath: any) =>
    !isNilOrEmpty(imagePath) ? `${config.BASE_EID_URL}${imagePath}` : undefined

export const defaultApplicationLogoImage =
    '/webcdn/Images/AppLogos/Genric-1.png'

export const getWorkflowUrlForNewTab = (
    wfParams: any,
    requestWorkflowName: any,
) => {
    let queryParams = [
        'wfMsContext=true',
        `wfMsUrl=${
            window.location.origin
        }#w/${requestWorkflowName}?popupNav=true&CloseWindowAfter=0${
            wfParams?.length > 0 ? '&' + wfParams.join('&') : ''
        }`,
    ]

    if (wfParams?.length > 0) {
        queryParams = queryParams.concat(wfParams)
    }

    const queryString = queryParams.join('&')

    return `${config.BASE_EID_URL}/ui?hideHeader=true&${queryString}`
}

export const showSearchToLoadMessage = (
    route: string,
    searchKey: any,
    isEnterPressed: boolean,
    searchToLoadConfig: any,
) => {
    // Get default settings from config
    const defaultSetting = searchToLoadConfig?.Default || {
        minCharacters: 0,
        searchToLoadEnabled: false,
        allowEmptySearch: false,
    }

    // Find the specific route config using uiRoute from JSON
    const routeConfig = searchToLoadConfig?.routes?.find(
        (r: any) => r.uiRoute === route,
    )

    // Merge default with route-specific config (route config overrides default)
    const finalConfig = routeConfig || defaultSetting

    // If searchToLoadEnabled is false, return false
    if (!finalConfig.searchToLoadEnabled) {
        return false
    }

    // If allowEmptySearch is allowed AND isEnterPressed, return false
    if (finalConfig.allowEmptySearch && isEnterPressed) {
        return false
    }

    // Check minimum character length from config
    const minCharacters = finalConfig.minCharacters || 0
    if (minCharacters === 0) {
        return false
    }
    return searchKey.length < minCharacters
}
export const getNumberOrDefault = (number: number, defaultValue: number) => {
    if (isNaN(number)) return defaultValue
    return number
}

export const ITEM_COMMENT_MAX_LENGTH = getNumberOrDefault(
    config.ITEM_COMMENT_MAX_LENGTH,
    500,
)

export const ITEM_COMMENT_MIN_LENGTH = getNumberOrDefault(
    config.ITEM_COMMENT_MIN_LENGTH,
    0,
)

